import styled from 'styled-components';

export const KnowledgePageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const KnowledgeHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
  padding-right: 4px;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderRowResponsive = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1375px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 1375px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

export const HeaderInfo = styled.div`
display: flex;
flex-direction: column;
gap: 8px;
align-self: flex-start;
`;

export const SearchContainer = styled.div`
  min-width: 200px;
  max-width: 257px;
  flex: 0 0 auto;

  
`;

export const ViewModeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 1375px) {
    justify-content: flex-end;
    width: 100%;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  color: ${(props) => props.theme.colors.davysGrey || '#5C5C5C'};
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px;
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid ${(props) => props.theme.colors.platinum || '#E5E5E5'};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.white || '#FFFFFF'};
  cursor: pointer;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;

export const CardIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: ${(props) => props.$bgColor || '#E3F2FD'};
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const CardTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${(props) => props.theme.colors.title || '#1A1A1A'};
  margin-bottom: 4px;
`;

export const CardMeta = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.davysGrey || '#5C5C5C'};
`;

